export const MARGIN_BOTTOM = 20
export const MARGIN_TOP = 20



// WEBPACK FOOTER //
// ./src/constants/layout.js